import JSColor from '@eastdesire/jscolor';

const colorPicker = {
  /**
   * Create color picker
   * @param  {HTMLDivElement} container
   * @param  {Object} props
   * @return {void}
   */
  create(container, props) {
    this.props = props;
    this.container = container;

    this.createColorPicker();
  },

  /**
   * Create color picker
   * @return {void}
   */
  createColorPicker() {
    const input = this.container.querySelector('.js-color-picker');

    // eslint-disable-next-line no-new
    new JSColor(input, {
      uppercase: false,
      required: false,
    });
  },
};

export default colorPicker;
